__webpack_require__.p = "/grpahing-calc/";